import { Text } from "components";
import { useFormGroup } from "./formGroup";

type Props = React.HTMLAttributes<HTMLDivElement>;

const FormHelperError: React.FC<Props> = (props) => {
  const { error } = useFormGroup();
  return error ? (
    <Text css={{ color: "$error", fontSize: "$2" }} {...props}>
      {error.message}
    </Text>
  ) : null;
};

export { FormHelperError };
